/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var AppointmentsIcon = createIcon("AppointmentsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 3v17a2 2 0 01-2 2H3a2 2 0 01-2-2V3a1 1 0 011-1h20a1 1 0 011 1ZM7 5.5a1.001 1.001 0 010-2 1.001 1.001 0 010 2Zm10 0a1.001 1.001 0 010-2 1.001 1.001 0 010 2Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2a1 1 0 00-1 1v4h22V3a1 1 0 00-1-1ZM7 5.5a1.001 1.001 0 010-2 1.001 1.001 0 010 2Zm10 0a1.001 1.001 0 010-2 1.001 1.001 0 010 2Z",
    fill: "#F9423A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19a5 5 0 110-10 5 5 0 010 10Zm0-1a4 4 0 100-8 4 4 0 000 8Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.704 14.996a.5.5 0 01-.708.708l-1.35-1.35A.5.5 0 0111.5 14v-2.7a.5.5 0 111 0v2.493l1.204 1.203Z",
    fill: "#1A1A1A"
  })));
}, {});